enum Expression {
  //ADD_ANOTHER=788838,
  ADD_NEW = 'tws.card.add-new',
  ALLERGIES = 'tws.information-bar.allergies',
  ALERTS = 'tws.information-bar.alerts',
  APPLY='tws.datepicker.apply',
  APPROVED = 'tws.status.approved',
  AVAILABLE = 'tws.status.available',
  AWAITING_APPROVAL = 'tws.status.awaitingapproval',
  CANCEL = 'tws.biometry.cancel',
  CANCEL_FILE_UPLOADER = 'tws.file-uploader.cancel',
  CANCELED = 'tws.status.canceled',
  CAPTURE_FINGERPRINT = 'tws.biometry.capture-fingerprint',
  CHANGE_RECORD = 'tws.finder.change-record',
  CHARACTERS_REMAINING = 'tws.text-area.remaining-characters',
  //CHECK_ALL=318791,
  CLEAR='tws.datepicker.clear',
  CLEAR_ALL = 'tws.filter.clear-all',
  CONFIRM='tws.steps.confirm',
  CONFIRMED = 'tws.status.confirmed',
  //COUNTRY_CODE_NOT_INFORMED=571165,
  //DECREASE_FONT=872308,
  //DELETE=305219,
  //DETAIL_INVALID_FORM_MSG=796176,
  DETECT_TOUCH = 'tws.biometry.detect-touch',
  DONE = 'tws.status.done',
  EDIT = 'tws.step.edit',
  FILTER = 290097,
  FILTER_BY = 'tws.filter.filter-by',
  GO_TO_NEXT_STEP = 'tws.step.next-step',
  HIDE_PASSWORD = 788836,
  HOUR = 'calendar-hour',
  INCREASE_FONT = 872302,
  INVALID_VALUE = 509632,
  LOAD_MORE = 'tws.deck.load-more',
  MAXIMUM_CHAR_LIMIT_EXCEEDED = 867484,
  MISSED = 'tws.status.missed',
  NA = 'tws.information-bar.na',
  NEXT='tws.steps.next',
  NOT_APPROVED = 'tws.status.notapproved',
  NO_APPOINTMENTS='tws.datepicker.no-appointments',
  OFF = 'tws.switch.off',
  ON = 'tws.switch.on',
  OR_PRESS_ENTER='tws.step.press-enter',
  PERSONAL_INFORMATION = 'tws.information-bar.personal-information',
  TAKE_PHOTO = 'tws.photo-uploader.take-photo',
  PROCESSING = 'tws.status.processing',
  PREVIEW = 'tws.file-uploader.preview',
  READY = 'tws.status.ready',
  REMOVE = 'tws.biometry.remove',
  //REQUIRED_FIELD=629377,
  //RESET_FONT=872312,
  RESULTS_NOT_FOUND = 'tws.not-found.results-not-found',
  RETRY = 'tws.biometry.retry',
  FAILED = 'tws.file-uploader.failed',
  //SAVE=330131,
  SEARCH = 'tws.finder.search',
  SEE = 'tws.event-token-list.see-more',
  SEE_ALL_SECTIONS = 'tws.trail.see-all',
  SELECTED_PHOTO = 'tws.photo-uploader.selected-photo',
  SUPERSCRIPTION = 'tws.superscription.title',
  SELECT_FILE = 'tws.file-uploader.select-file',
  //SHOW_PASSWORD=788834,
  TODAY='tws.datepicker.today',
  //TOGGLE_CONTRAST=872298,
  USER_NOT_FOUND = 'tws.biometry.user-not-found',
  WAITING = 'tws.status.waiting',
}

export default Expression;
